import { FaBan } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";

const DropdownItemExameBloqueado = ({ notif, onClick }) => {
    const info = notif.atendimento_info;
    if (!info) return null;

    let dataFormatada = info.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
            try {
                dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
            } catch (e) {}
    }

    return (
        <DropdownItemBase
            icon={<FaBan />}
            text="text-danger"
            titulo="Exame Bloqueado"
            descricao={
                <>
                    <div>Paciente: <strong>{info.beneficiario_nome}</strong></div>
                    {notif.dados?.exame_nome && isNaN(notif.dados.exame_nome) && (
                        <div>Exame: <strong>{notif.dados.exame_nome}</strong></div>
                    )}
                </>
            }
            subDescricao={
                <>
                    <div>Programa: {info.programa_nome}</div>
                    {notif.dados?.medico_nome && (
                        <div>Médico: {notif.dados.medico_nome}</div>
                    )}
                </>
            }
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemExameBloqueado;
